import React from 'react';
import classNames from 'classnames';
import { SkipLinks, SkipLinksWithoutFooter } from '../SkipLinks';
import styles from './IsolationPage.module.scss';
import { Button, Icon, IconList } from 'components/core';

type Props = {
  back?: string | URL;
  title?: React.ReactNode;
  controls?: React.ReactNode;
  children?: React.ReactNode;
  // Pages with no footer should pass false so the "Skip to footer" link
  // doesn't point at nothing.
  hasFooter?: boolean;
};

const IsolationPage = ({
  back,
  title,
  controls,
  children,
  hasFooter = true,
}: Props) => {
  const PageSkipLinks = hasFooter ? SkipLinks : SkipLinksWithoutFooter;

  return (
    <>
      <PageSkipLinks hasContainer={false} />
      <header
        className={classNames(styles.IsolationPageHeader, {
          // Without a Back button the header has no left inset of its own.
          [styles.noBackButton]: !back,
        })}
      >
        {back ? (
          <Button
            to={back}
            iconOnly
            className={styles.BackButton}
            aria-label="Back"
            variant="ghost"
          >
            <Icon icon={IconList.light.faArrowLeft} />
          </Button>
        ) : null}
        {title}
        {controls ? <div className={styles.Controls}>{controls}</div> : null}
      </header>
      <main id="main" tabIndex={-1}>
        <div className="container">{children}</div>
      </main>
    </>
  );
};

export default IsolationPage;
